import { Component } from '@angular/core';
import { OrderListComponent } from "../../../components/user-dashboard-component/orders/order-list-component/order-list-component";

@Component({
  selector: 'app-user-orders',
  imports: [OrderListComponent],
  templateUrl: './user-orders.html',
  styleUrl: './user-orders.scss'
})
export class UserOrders {}

